import { FC } from 'react'
import styles from './ThePodVersusOtherSleepAids.module.scss'
import {
	TableCheckType,
	TableItem,
	ThePodVersusOtherSleepAidsProps,
} from './ThePodVersusOtherSleepAids.types'
import { Button } from 'components/Phantom/Button'
import { Type } from 'components/Type'

export const ThePodVersusOtherSleepAids: FC<ThePodVersusOtherSleepAidsProps> = () => {
	return (
		<div className={styles.container}>
			<Type.Headline2>Why the Pod is the best sleep aid</Type.Headline2>

			<Table />

			<Button.Dark
				id={'sleep-aids-read-more'}
				href={'/product/pod-cover'}
			>
				Shop the Pod
			</Button.Dark>
		</div>
	)
}

const Table = () => {
	return (
		<table className={styles.table}>
			<thead>
				<tr>
					<th></th>
					<th>
						<Type.Headline6 as={'span'}>The Pod</Type.Headline6>
					</th>
					<th>
						<Type.Headline6 as={'span'}>Melatonin</Type.Headline6>
					</th>
					<th>
						<Type.Headline6 as={'span'}>Prescription sleep medicine</Type.Headline6>
					</th>
					<th>
						<Type.Headline6 as={'span'}>Wearables</Type.Headline6>
					</th>
				</tr>
			</thead>
			<tbody>
				{tableItems.map((item) => (
					<tr key={item.title}>
						<td>
							<Type.Body2 as={'span'}>{item.title}</Type.Body2>
						</td>
						{item.checks.map((check, index) => {
							switch (check) {
								case TableCheckType.HIGHLIGHT:
									return (
										<td key={`${item.title}-${check}-${index}`}>
											<HighlightCheck />
										</td>
									)
								case TableCheckType.CHECK:
									return (
										<td key={`${item.title}-${check}-${index}`}>
											<Check />
										</td>
									)
								case TableCheckType.NONE:
									return (
										<td key={`${item.title}-${check}-${index}`}>
											<span className={styles.none}></span>
										</td>
									)
								default:
									return <td key={check}></td>
							}
						})}
					</tr>
				))}
			</tbody>
		</table>
	)
}

const tableItems: TableItem[] = [
	{
		title: 'Helps you fall asleep faster',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.CHECK,
			TableCheckType.CHECK,
			TableCheckType.NONE,
		],
	},
	{
		title: 'Helps you stay asleep',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.CHECK,
			TableCheckType.CHECK,
			TableCheckType.NONE,
		],
	},
	{
		title: 'Nothing to wear or charge',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.CHECK,
			TableCheckType.CHECK,
			TableCheckType.NONE,
		],
	},
	{
		title: 'Tracks your sleep',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.NONE,
			TableCheckType.NONE,
			TableCheckType.CHECK,
		],
	},
	{
		title: 'No consumable needed',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.NONE,
			TableCheckType.NONE,
			TableCheckType.CHECK,
		],
	},
	{
		title: 'No side-effects',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.NONE,
			TableCheckType.NONE,
			TableCheckType.CHECK,
		],
	},
	{
		title: 'Non-addictive',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.NONE,
			TableCheckType.NONE,
			TableCheckType.CHECK,
		],
	},
	{
		title: 'Safe for long-term use',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.NONE,
			TableCheckType.NONE,
			TableCheckType.CHECK,
		],
	},
	{
		title: 'Gives you balanced sleep',
		checks: [
			TableCheckType.HIGHLIGHT,
			TableCheckType.NONE,
			TableCheckType.NONE,
			TableCheckType.NONE,
		],
	},
]

const HighlightCheck = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 32"
		fill="none"
	>
		<g clipPath="url(#clip0_14131_37724)">
			<circle
				cx="16"
				cy="16"
				r="16"
				fill="#1862FF"
			/>
			<path
				d="M13.5008 18.4998L10.3107 15.3097C10.2122 15.2112 10.0953 15.1331 9.9666 15.0797C9.83791 15.0264 9.69999 14.999 9.56069 14.999C9.4214 14.999 9.28347 15.0264 9.15478 15.0797C9.02609 15.1331 8.90916 15.2112 8.81067 15.3097C8.71218 15.4082 8.63405 15.5251 8.58074 15.6538C8.52744 15.7825 8.5 15.9204 8.5 16.0597C8.5 16.199 8.52744 16.3369 8.58074 16.4656C8.63405 16.5943 8.71218 16.7112 8.81067 16.8097L14.0008 21.9999L22.2541 11.8046C22.4141 11.6076 22.5011 11.3615 22.5011 11.1075V11.0335C22.501 10.8236 22.437 10.6187 22.3176 10.446C22.1983 10.2733 22.0291 10.1411 21.8328 10.0668C21.6364 9.99258 21.4221 9.97986 21.2183 10.0304C21.0146 10.0809 20.831 10.1922 20.692 10.3495L13.5008 18.4998Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_14131_37724">
				<rect
					width="32"
					height="32"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
)

const Check = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 32"
		fill="none"
	>
		<g clipPath="url(#clip0_14131_37797)">
			<circle
				cx="16"
				cy="16"
				r="16"
				fill="#F2F2F2"
			/>
			<path
				d="M13.5008 18.4998L10.3107 15.3097C10.2122 15.2112 10.0953 15.1331 9.9666 15.0797C9.83791 15.0264 9.69999 14.999 9.56069 14.999C9.4214 14.999 9.28347 15.0264 9.15478 15.0797C9.02609 15.1331 8.90916 15.2112 8.81067 15.3097C8.71218 15.4082 8.63405 15.5251 8.58074 15.6538C8.52744 15.7825 8.5 15.9204 8.5 16.0597C8.5 16.199 8.52744 16.3369 8.58074 16.4656C8.63405 16.5943 8.71218 16.7112 8.81067 16.8097L14.0008 21.9999L22.2541 11.8046C22.4141 11.6076 22.5011 11.3615 22.5011 11.1075V11.0335C22.501 10.8236 22.437 10.6187 22.3176 10.446C22.1983 10.2733 22.0291 10.1411 21.8328 10.0668C21.6364 9.99258 21.4221 9.97986 21.2183 10.0304C21.0146 10.0809 20.831 10.1922 20.692 10.3495L13.5008 18.4998Z"
				fill="#171920"
			/>
		</g>
		<defs>
			<clipPath id="clip0_14131_37797">
				<rect
					width="32"
					height="32"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
)
